import { SyncEntityRequest } from "@/Contracts/Others/RecentActivityFeed/index";
import axios, { AxiosResponse } from "axios";
import urlencode from "urlencode";

import {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest
} from "@/Utils/Service/BackendService";

import {
	CustomView,
	CustomViewResponse,
	CustomViewsMetadata,
	DeletedRecord,
	SyncData,
	ZomentumEntities,
	ListPagePostRequest,
	FetchCustomDistributorAuditLogsRequest
} from "@/Contracts";
import {
	getTableQueryFilters,
	includeChildEntities,
	ChildEntityHydrationParams
} from "@/Contracts/Utils";
import {
	SalesActivityRequest,
	AggregateSalesActivityResponse,
	SalesActivityResponse,
	SalesActivitySection,
	SalesActivity,
	AddSalesActivityCommentRequest,
	AddLogCallRequest,
	AddLogEmailRequest,
	AddTaskRequest,
	AddMeetingRequest,
	SalesActivityAutomation,
	AddSalesActivityAutomationRequest,
	SalesActivityAutomationResponse,
	SalesActivityAutomationMetadataRequest,
	SalesActivityAutomationMetadataResponse,
	HistoryActivityResponse,
	HistoryActivityRequest,
	GetOneSaleActivityRequest,
	SalesActivityPageRequest,
	MeetingClashStatusResponse,
	FetchCategoryBasedAuditLogsRequest,
	EditSalesActivityAutomationRequest,
	RetryFailedAuditLogsRequest,
	SalesActivityAutomationAuditLogsRequest,
	SalesActivityAutomationAuditLogsResponse,
	LogEmailBodyRespone,
	ConflictedMeetigs,
	WebhookConfigCreateRequest,
	WebhookTestResponse
} from "@/Contracts/Others/SalesActivity";
import { RecentActivityFeedType } from "@/Contracts/Others/RecentActivityFeed";

const salesActivityUrl = "/v3/feeds";
const deleteCommentUrl = "/v2/comments/{comment_id}";
const addCommentUrl = "/v2/comments";
const editCommentUrl = "/v2/comments/{comment_id}";
const deleteLogCallUrl = "/v2/activities/sales/call_log/{log_call_id}";
const addLogCallUrl = "/v2/activities/sales/call_log";
const editLogCallUrl = "/v2/activities/sales/call_log/{log_call_id}";
const deleteLogEmailUrl = "/v2/activities/sales/email_log/{log_email_id}";
const addLogEmailUrl = "/v2/activities/sales/email_log";
const editLogEmailUrl = "/v2/activities/sales/email_log/{log_email_id}";
const getLogEmailBodyUrl = "/v2/activities/sales/email_log/{log_email_id}/body";
const deleteMeetingUrl = "/v2/activities/sales/meeting/{meeting_id}";
const addMeetingUrl = "/v2/activities/sales/meeting";
const editMeetingUrl = "/v2/activities/sales/meeting/{meeting_id}";
const getOneMeetingURL = "/v3/feeds/{meeting_id}";
const getOneTaskURL = "/v3/feeds/{task_id}";
const getOneEmailLogURL = "/v3/feeds/{log_email_id}";
const getOneCallLogURL = "/v3/feeds/{log_call_id}";
const getOneCommentURL = "/v3/feeds/{comment_id}";
const getOneSalesActivityURL = "/v3/feeds/{entity_id}";
const deleteOneSalesActivityURL =
	"/v2/activities/sales/{entity_type}/{entity_id}";
const deleteOneCommentURL = "/v2/comments/{comment_id}";
const fetchMeetingClashStatusURL = "/v2/activities/sales/meeting/clash/";

const deleteTaskUrl = "/v2/activities/sales/task/{task_id}";
const addTaskUrl = "/v2/activities/sales/task";
const editTaskUrl = "/v2/activities/sales/task/{task_id}";
const salesActivityAutomationsUrl = "/{version}/automation/sales";
const salesActivityAutomationDetailsUrl =
	salesActivityAutomationsUrl + "/{sales_activity_automation_id}";
const getSalesActivityAutomationMetadataUrl =
	salesActivityAutomationsUrl +
	"/metadata?trigger_action_type={trigger_action_type}&trigger_entity_type={trigger_entity_type}";
const reorderSalesActivityAutomationUrl =
	salesActivityAutomationsUrl + "/reorder";
const deleteSalesActivityAutomationUrl =
	salesActivityAutomationsUrl + "/{sales_activity_automation_id}";
const addSalesActivityAutomationUrl = salesActivityAutomationsUrl;
const editSalesActivityAutomationUrl =
	salesActivityAutomationsUrl + "/{sales_activity_automation_id}";

// will be replacing the above ones with a generic code

const getAuditLogs = "/v2/audit/logs";

const syncWithPSAUrl = "/v2/integration/psa_sync";
const getUpdatedSyncDataUrl = "/v2/integration/get_sync_data";

const fetchAuditLogsURL = "/v2/audit/logs/all";
const retryFailedAuditLogURL = "/v2/integration/sync/retry";

const fetchCustomDistributorAuditLogsURL =
	"/v2/companies/integrations/custom_distributor/audit_logs/?custom_distributor_id={distributor_id}";

const salesActivityAutomationAuditLogsURL =
	"/v2/automation/sales/logs?filters=rule_id:eq:{rule_id}";

const getAuditLogRedirectLinkURL = "/v2/audit/url/{id}";

const getSalesActivityViewMetadataURL =
	"/v2/views/metadata?entity_type={entity_type}";

const getAllSalesActivityAndAutomationViewURL =
	"/v2/views?entity_type={entity_type}";
const createSalesActivityAndAutomationViewURL = "/v2/views";
const updateSalesActivityAndAutomationViewURL = "/v2/views/{view_id}";
const deleteSalesActivityAndAutomationViewURL = "/v2/views/{view_id}";
const getSalesActivityAndAutomationListPostURL =
	salesActivityAutomationsUrl + "/view";
const getConflictMeetingsDetailURL =
	"/v2/activities/sales/meeting/show_calendar";

export const getAllSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let completedUrl = "";
		let overdueUrl = "";
		let upcomingUrl = "";

		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			completedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");

			overdueUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");

			upcomingUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			completedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			completedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			completedUrl += `&included_feed_types=${RecentActivityFeedType.Task},${RecentActivityFeedType.Email},${RecentActivityFeedType.Meeting},${RecentActivityFeedType.LogCall},${RecentActivityFeedType.LogEmail},${RecentActivityFeedType.Comment}`;
			completedUrl += `&feed_section=${SalesActivitySection.Completed}`;
			completedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";

			overdueUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			overdueUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			overdueUrl += `&included_feed_types=${RecentActivityFeedType.Task},${RecentActivityFeedType.Email},${RecentActivityFeedType.Meeting},${RecentActivityFeedType.LogCall},${RecentActivityFeedType.LogEmail},${RecentActivityFeedType.Comment}`;
			overdueUrl += `&feed_section=${SalesActivitySection.Overdue}`;
			overdueUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";

			upcomingUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			upcomingUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			upcomingUrl += `&included_feed_types=${RecentActivityFeedType.Task},${RecentActivityFeedType.Email},${RecentActivityFeedType.Meeting},${RecentActivityFeedType.LogCall},${RecentActivityFeedType.LogEmail},${RecentActivityFeedType.Comment}`;
			upcomingUrl += `&feed_section=${SalesActivitySection.Upcoming}`;
			upcomingUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}

		completedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		upcomingUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		overdueUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			completedUrl += `&should_fetch_shared_activities=true`;
			upcomingUrl += `&should_fetch_shared_activities=true`;
			overdueUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(completedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>,
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(overdueUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>,
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(upcomingUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Completed] =
			salesActivityResponse[0].data;
		aggregateSalesActivityResponse[SalesActivitySection.Overdue] =
			salesActivityResponse[1].data;
		aggregateSalesActivityResponse[SalesActivitySection.Upcoming] =
			salesActivityResponse[2].data;

		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getAllCompletedSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let completedUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			completedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			completedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			completedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			completedUrl += `&included_feed_types=${RecentActivityFeedType.Task},${RecentActivityFeedType.Email},${RecentActivityFeedType.Meeting},${RecentActivityFeedType.LogCall},${RecentActivityFeedType.LogEmail},${RecentActivityFeedType.Comment}`;
			completedUrl += `&feed_section=${SalesActivitySection.Completed}`;
			completedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		completedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			completedUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(completedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Completed] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getAllOverdueSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let overdueUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			overdueUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			overdueUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			overdueUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			overdueUrl += `&included_feed_types=${RecentActivityFeedType.Task},${RecentActivityFeedType.Email},${RecentActivityFeedType.Meeting},${RecentActivityFeedType.LogCall},${RecentActivityFeedType.LogEmail},${RecentActivityFeedType.Comment}`;
			overdueUrl += `&feed_section=${SalesActivitySection.Overdue}`;
			overdueUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		overdueUrl += salesActivityRequest.relatedOpportunities
			? `&opportunity_ids=${salesActivityRequest.relatedOpportunities.join(
					","
			  )}`
			: "";
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			overdueUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(overdueUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Overdue] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getAllUpcomingSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let upcomingUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			upcomingUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			upcomingUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			upcomingUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			upcomingUrl += `&included_feed_types=${RecentActivityFeedType.Task},${RecentActivityFeedType.Email},${RecentActivityFeedType.Meeting},${RecentActivityFeedType.LogCall},${RecentActivityFeedType.LogEmail},${RecentActivityFeedType.Comment}`;
			upcomingUrl += `&feed_section=${SalesActivitySection.Upcoming}`;
			upcomingUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		upcomingUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			upcomingUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(upcomingUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Upcoming] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getNotesSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let completedUrl = "";
		let pinnedUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			completedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
			pinnedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			completedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			completedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			completedUrl += `&included_feed_types=${RecentActivityFeedType.Comment}`;
			completedUrl += `&feed_section=${SalesActivitySection.Completed}`;
			completedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
			pinnedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			pinnedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			pinnedUrl += `&included_feed_types=${RecentActivityFeedType.Comment}`;
			pinnedUrl += `&feed_section=${SalesActivitySection.Pinned}`;
			pinnedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		completedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		pinnedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			completedUrl += `&should_fetch_shared_activities=true`;
			pinnedUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(completedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>,
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(pinnedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Completed] =
			salesActivityResponse[0].data;
		aggregateSalesActivityResponse[SalesActivitySection.Pinned] =
			salesActivityResponse[1].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getNotesPinnedSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let pinnedUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			pinnedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			pinnedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			pinnedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			pinnedUrl += `&included_feed_types=${RecentActivityFeedType.Comment}`;
			pinnedUrl += `&feed_section=${SalesActivitySection.Pinned}`;
			pinnedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		pinnedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			pinnedUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(pinnedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Pinned] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getNotesCompletedSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let completedUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			completedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			completedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			completedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			completedUrl += `&included_feed_types=${RecentActivityFeedType.Comment}`;
			completedUrl += `&feed_section=${SalesActivitySection.Completed}`;
			completedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		completedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			completedUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(completedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Completed] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getTasksSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let completedUrl = "";
		let overdueUrl = "";
		let upcomingUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			completedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
			overdueUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
			upcomingUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			completedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			completedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			completedUrl += `&included_feed_types=${RecentActivityFeedType.Task}`;
			completedUrl += `&feed_section=${SalesActivitySection.Completed}`;
			completedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
			overdueUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			overdueUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			overdueUrl += `&included_feed_types=${RecentActivityFeedType.Task}`;
			overdueUrl += `&feed_section=${SalesActivitySection.Overdue}`;
			overdueUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
			upcomingUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			upcomingUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			upcomingUrl += `&included_feed_types=${RecentActivityFeedType.Task}`;
			upcomingUrl += `&feed_section=${SalesActivitySection.Upcoming}`;
			upcomingUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		completedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		overdueUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		upcomingUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			completedUrl += `&should_fetch_shared_activities=true`;
			upcomingUrl += `&should_fetch_shared_activities=true`;
			overdueUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(completedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>,
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(overdueUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>,
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(upcomingUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Completed] =
			salesActivityResponse[0].data;
		aggregateSalesActivityResponse[SalesActivitySection.Overdue] =
			salesActivityResponse[1].data;
		aggregateSalesActivityResponse[SalesActivitySection.Upcoming] =
			salesActivityResponse[2].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getTasksCompletedSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let completedUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			completedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			completedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			completedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			completedUrl += `&included_feed_types=${RecentActivityFeedType.Task}`;
			completedUrl += `&feed_section=${SalesActivitySection.Completed}`;
			completedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		completedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			completedUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(completedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Completed] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getTasksOverdueSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let overdueUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			overdueUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			overdueUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			overdueUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			overdueUrl += `&included_feed_types=${RecentActivityFeedType.Task}`;
			overdueUrl += `&feed_section=${SalesActivitySection.Overdue}`;
			overdueUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		overdueUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			overdueUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(overdueUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Overdue] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getTasksUpcomingSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let upcomingUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			upcomingUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			upcomingUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			upcomingUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			upcomingUrl += `&included_feed_types=${RecentActivityFeedType.Task}`;
			upcomingUrl += `&feed_section=${SalesActivitySection.Upcoming}`;
			upcomingUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		upcomingUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			upcomingUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(upcomingUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Upcoming] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getMeetingsSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let completedUrl = "";
		let upcomingUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			completedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
			upcomingUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			completedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			completedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			completedUrl += `&included_feed_types=${RecentActivityFeedType.Meeting}`;
			completedUrl += `&feed_section=${SalesActivitySection.Completed}`;
			completedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
			upcomingUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			upcomingUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			upcomingUrl += `&included_feed_types=${RecentActivityFeedType.Meeting}`;
			upcomingUrl += `&feed_section=${SalesActivitySection.Upcoming}`;
			upcomingUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		completedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		upcomingUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(completedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>,
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(upcomingUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Completed] =
			salesActivityResponse[0].data;
		aggregateSalesActivityResponse[SalesActivitySection.Upcoming] =
			salesActivityResponse[1].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getMeetingsCompletedSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let completedUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			completedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			completedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			completedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			completedUrl += `&included_feed_types=${RecentActivityFeedType.Meeting}`;
			completedUrl += `&feed_section=${SalesActivitySection.Completed}`;
			completedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		completedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(completedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Completed] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getMeetingsUpcomingSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let upcomingUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			upcomingUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			upcomingUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			upcomingUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			upcomingUrl += `&included_feed_types=${RecentActivityFeedType.Meeting}`;
			upcomingUrl += `&feed_section=${SalesActivitySection.Upcoming}`;
			upcomingUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		upcomingUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(upcomingUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Upcoming] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getCallsSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let completedUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			completedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			completedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			completedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			completedUrl += `&included_feed_types=${RecentActivityFeedType.LogCall}`;
			completedUrl += `&feed_section=${SalesActivitySection.Completed}`;
			completedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		completedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		if (
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.Opportunity ||
			salesActivityRequest.entity?.entityType ===
				ZomentumEntities.VendorOpportunity
		) {
			completedUrl += `&should_fetch_shared_activities=true`;
		}
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(completedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Completed] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getEmailsSalesActivity = async (
	salesActivityRequest: SalesActivityRequest
): Promise<AggregateSalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityRequest.filters,
			false
		);
		let completedUrl = "";
		if (
			salesActivityRequest.paginate &&
			salesActivityRequest.next &&
			salesActivityRequest.next.length > 0
		) {
			completedUrl +=
				`${salesActivityRequest.next}` +
				(appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "");
		} else {
			completedUrl += `entity_type=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityType
					: ""
			}`;
			completedUrl += `&entity_id=${
				salesActivityRequest.entity
					? salesActivityRequest.entity.entityId
					: ""
			}`;
			completedUrl += `&included_feed_types=${RecentActivityFeedType.Email},${RecentActivityFeedType.LogEmail}`;
			completedUrl += `&feed_section=${SalesActivitySection.Completed}`;
			completedUrl +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
		}
		completedUrl += `&opportunity_ids=${salesActivityRequest.relatedOpportunities?.join(
			","
		)}`;
		const aggregateSalesActivityResponse =
			new AggregateSalesActivityResponse();
		const salesActivityResponse: AxiosResponse<SalesActivityResponse>[] =
			await axios.all([
				axios(
					postRequest(
						salesActivityUrl,
						{ query_string: urlencode(completedUrl) },
						true,
						false,
						false
					)
				) as Promise<AxiosResponse<SalesActivityResponse>>
			]);
		aggregateSalesActivityResponse[SalesActivitySection.Completed] =
			salesActivityResponse[0].data;
		return aggregateSalesActivityResponse;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getHistoryActivities = async (
	getHistoryActivitiesRequest: HistoryActivityRequest
): Promise<HistoryActivityResponse> => {
	try {
		const getAuditLogsURL = `${getAuditLogs}?limit=${
			getHistoryActivitiesRequest.limit
		}&entity_type=${
			getHistoryActivitiesRequest.entity?.entityType ?? ""
		}&entity_id=${
			getHistoryActivitiesRequest.entity?.entityId ?? ""
		}&page=${getHistoryActivitiesRequest.page}`;
		const response: AxiosResponse<HistoryActivityResponse> = await axios(
			getRequest(getAuditLogsURL, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteComment = async (
	deleteCommentRequest: SalesActivity
): Promise<DeletedRecord> => {
	try {
		const response: AxiosResponse<DeletedRecord> = await axios(
			deleteRequest(
				deleteCommentUrl.replace(
					"{comment_id}",
					deleteCommentRequest.id
				),
				null,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addComment = async (
	addCommentRequest: AddSalesActivityCommentRequest,
	isCrossAssign: boolean
): Promise<SalesActivity> => {
	try {
		const response: AxiosResponse<SalesActivity> = await axios(
			postRequest(
				`${addCommentUrl}?cross_assign=${isCrossAssign.toString()}`,
				addCommentRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const editComment = async (
	editCommentRequest: SalesActivity
): Promise<SalesActivity> => {
	try {
		const response: AxiosResponse<SalesActivity> = await axios(
			putRequest(
				editCommentUrl.replace("{comment_id}", editCommentRequest.id),
				editCommentRequest.feed_details,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteLogCall = async (
	deleteLogCallRequest: SalesActivity
): Promise<DeletedRecord> => {
	try {
		const response: AxiosResponse<DeletedRecord> = await axios(
			deleteRequest(
				deleteLogCallUrl.replace(
					"{log_call_id}",
					deleteLogCallRequest.id
				),
				null,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addLogCall = async (
	addLogCallRequest: AddLogCallRequest,
	isCrossAssign: boolean
): Promise<SalesActivity> => {
	try {
		const response: AxiosResponse<SalesActivity> = await axios(
			postRequest(
				`${addLogCallUrl}?cross_assign=${isCrossAssign.toString()}`,
				addLogCallRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const editLogCall = async (
	editLogCallRequest: SalesActivity
): Promise<SalesActivity> => {
	try {
		const response: AxiosResponse<SalesActivity> = await axios(
			putRequest(
				editLogCallUrl.replace("{log_call_id}", editLogCallRequest.id),
				editLogCallRequest.feed_details,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteLogEmail = async (
	deleteLogEmailRequest: SalesActivity
): Promise<DeletedRecord> => {
	try {
		const response: AxiosResponse<DeletedRecord> = await axios(
			deleteRequest(
				deleteLogEmailUrl.replace(
					"{log_email_id}",
					deleteLogEmailRequest.id
				),
				null,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addLogEmail = async (
	addLogEmailRequest: AddLogEmailRequest
): Promise<SalesActivity> => {
	try {
		const response: AxiosResponse<SalesActivity> = await axios(
			postRequest(addLogEmailUrl, addLogEmailRequest, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getLogEmailBody = async (
	id: string
): Promise<LogEmailBodyRespone> => {
	try {
		const response: AxiosResponse<LogEmailBodyRespone> = await axios(
			getRequest(
				getLogEmailBodyUrl.replace("{log_email_id}", id),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const editLogEmail = async (
	editLogEmailRequest: SalesActivity
): Promise<SalesActivity> => {
	try {
		const response: AxiosResponse<SalesActivity> = await axios(
			putRequest(
				editLogEmailUrl.replace(
					"{log_email_id}",
					editLogEmailRequest.id
				),
				editLogEmailRequest.feed_details,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteTask = async (
	deleteTaskRequest: SalesActivity
): Promise<DeletedRecord> => {
	try {
		const response: AxiosResponse<DeletedRecord> = await axios(
			deleteRequest(
				deleteTaskUrl.replace("{task_id}", deleteTaskRequest.id),
				null,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addTask = async (
	addTaskRequest: AddTaskRequest,
	isCrossAssign: boolean
): Promise<SalesActivity> => {
	try {
		const response: AxiosResponse<SalesActivity> = await axios(
			postRequest(
				`${addTaskUrl}?cross_assign=${isCrossAssign.toString()}`,
				addTaskRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const editTask = async (
	editTaskRequest: SalesActivity
): Promise<SalesActivity> => {
	try {
		const response: AxiosResponse<SalesActivity> = await axios(
			putRequest(
				editTaskUrl.replace("{task_id}", editTaskRequest.id) +
					"?" +
					includeChildEntities([
						ChildEntityHydrationParams.PARENT_ENTITY_SUMMARY
					]),
				editTaskRequest.feed_details,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteMeeting = async (
	deleteMeetingRequest: SalesActivity
): Promise<DeletedRecord> => {
	try {
		const response: AxiosResponse<DeletedRecord> = await axios(
			deleteRequest(
				deleteMeetingUrl.replace(
					"{meeting_id}",
					deleteMeetingRequest.id
				),
				null,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addMeeting = async (
	addMeetingRequest: AddMeetingRequest
): Promise<SalesActivity> => {
	try {
		const response: AxiosResponse<SalesActivity> = await axios(
			postRequest(addMeetingUrl, addMeetingRequest, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const editMeeting = async (
	editMeetingRequest: SalesActivity
): Promise<SalesActivity> => {
	try {
		const response: AxiosResponse<SalesActivity> = await axios(
			putRequest(
				editMeetingUrl.replace("{meeting_id}", editMeetingRequest.id),
				editMeetingRequest.feed_details,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getSalesActivityAutomations = async (
	version = "v2"
): Promise<SalesActivityAutomationResponse> => {
	try {
		const response: AxiosResponse<SalesActivityAutomationResponse> =
			await axios(
				getRequest(
					salesActivityAutomationsUrl.replace("{version}", version),
					null,
					true,
					false,
					false
				)
			);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getSalesActivityAutomationMetadata = async (
	salesActivityAutomationMetadataRequest: SalesActivityAutomationMetadataRequest,
	version = "v2"
): Promise<SalesActivityAutomationMetadataResponse> => {
	try {
		let url = getSalesActivityAutomationMetadataUrl.replace(
			"{version}",
			version
		);
		if (
			salesActivityAutomationMetadataRequest &&
			salesActivityAutomationMetadataRequest.trigger_action_type
		) {
			url = url.replace(
				"{trigger_action_type}",
				salesActivityAutomationMetadataRequest.trigger_action_type
			);
		}
		if (
			salesActivityAutomationMetadataRequest &&
			salesActivityAutomationMetadataRequest.trigger_entity_type
		) {
			url = url.replace(
				"{trigger_entity_type}",
				salesActivityAutomationMetadataRequest.trigger_entity_type
			);
		}
		const response: AxiosResponse<SalesActivityAutomationMetadataResponse> =
			await axios(getRequest(url, null, true, false, false));
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getSalesActivityAutomationDetails = async (
	salesActivityAutomationId: string,
	version = "v2"
): Promise<SalesActivityAutomation> => {
	try {
		const response: AxiosResponse<SalesActivityAutomation> = await axios(
			getRequest(
				salesActivityAutomationDetailsUrl
					.replace(
						"{sales_activity_automation_id}",
						salesActivityAutomationId
					)
					.replace("{version}", version),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const reorderSalesActivityAutomation = async (
	reorderedSalesActivityAutomationList: SalesActivityAutomation[],
	version = "v2"
): Promise<SalesActivityAutomationResponse> => {
	try {
		const response: AxiosResponse<SalesActivityAutomationResponse> =
			await axios(
				putRequest(
					reorderSalesActivityAutomationUrl.replace(
						"{version}",
						version
					),
					{
						rules: reorderedSalesActivityAutomationList.map(
							salesActivityAutomation =>
								salesActivityAutomation.id
						)
					},
					true,
					false,
					false
				)
			);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteSalesActivityAutomation = async (
	deleteSalesActivityAutomationRequest: SalesActivityAutomation,
	version = "v2"
): Promise<DeletedRecord> => {
	try {
		const response: AxiosResponse<DeletedRecord> = await axios(
			deleteRequest(
				deleteSalesActivityAutomationUrl
					.replace(
						"{sales_activity_automation_id}",
						deleteSalesActivityAutomationRequest.id
					)
					.replace("{version}", version),
				null,
				true,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addSalesActivityAutomation = async (
	addSalesActivityAutomationRequest: AddSalesActivityAutomationRequest,
	version = "v2"
): Promise<SalesActivityAutomation> => {
	try {
		const response: AxiosResponse<SalesActivityAutomation> = await axios(
			postRequest(
				addSalesActivityAutomationUrl.replace("{version}", version),
				addSalesActivityAutomationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const editSalesActivityAutomation = async (
	editSalesActivityAutomationRequest: EditSalesActivityAutomationRequest,
	version = "v2"
): Promise<SalesActivityAutomation> => {
	try {
		const response: AxiosResponse<SalesActivityAutomation> = await axios(
			putRequest(
				editSalesActivityAutomationUrl
					.replace(
						"{sales_activity_automation_id}",
						editSalesActivityAutomationRequest.id
					)
					.replace("{version}", version),
				editSalesActivityAutomationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getOneMeeting = async (
	getOneSaleActivityRequest: GetOneSaleActivityRequest
): Promise<SalesActivity> => {
	try {
		let url = getOneMeetingURL.replace(
			"{meeting_id}",
			getOneSaleActivityRequest.salesActivityEntityId
		);
		url = `${url}?feed_type=${
			getOneSaleActivityRequest.SalesActivityEntityType
		}&${includeChildEntities([
			ChildEntityHydrationParams.PARENT_ENTITY_SUMMARY
		])}`;
		const response: AxiosResponse<SalesActivity> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
export const getOneTask = async (
	getOneSaleActivityRequest: GetOneSaleActivityRequest
): Promise<SalesActivity> => {
	try {
		let url = getOneTaskURL.replace(
			"{task_id}",
			getOneSaleActivityRequest.salesActivityEntityId
		);
		url = `${url}?feed_type=${
			getOneSaleActivityRequest.SalesActivityEntityType
		}&${includeChildEntities([
			ChildEntityHydrationParams.PARENT_ENTITY_SUMMARY
		])}`;
		const response: AxiosResponse<SalesActivity> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
export const getOneLogCall = async (
	getOneSaleActivityRequest: GetOneSaleActivityRequest
): Promise<SalesActivity> => {
	try {
		let url = getOneCallLogURL.replace(
			"{log_call_id}",
			getOneSaleActivityRequest.salesActivityEntityId
		);
		url = `${url}?feed_type=${
			getOneSaleActivityRequest.SalesActivityEntityType
		}&${includeChildEntities([
			ChildEntityHydrationParams.PARENT_ENTITY_SUMMARY
		])}`;
		const response: AxiosResponse<SalesActivity> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
export const getOneLogEmail = async (
	getOneSaleActivityRequest: GetOneSaleActivityRequest
): Promise<SalesActivity> => {
	try {
		let url = getOneEmailLogURL.replace(
			"{log_email_id}",
			getOneSaleActivityRequest.salesActivityEntityId
		);
		url = `${url}?feed_type=${
			getOneSaleActivityRequest.SalesActivityEntityType
		}&${includeChildEntities([
			ChildEntityHydrationParams.PARENT_ENTITY_SUMMARY
		])}`;
		const response: AxiosResponse<SalesActivity> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
export const getOneComment = async (
	getOneSaleActivityRequest: GetOneSaleActivityRequest
): Promise<SalesActivity> => {
	try {
		let url = getOneCommentURL.replace(
			"{comment_id}",
			getOneSaleActivityRequest.salesActivityEntityId
		);
		url = `${url}?feed_type=${
			getOneSaleActivityRequest.SalesActivityEntityType
		}&${includeChildEntities([
			ChildEntityHydrationParams.PARENT_ENTITY_SUMMARY
		])}`;
		const response: AxiosResponse<SalesActivity> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getUsersAllSalesActivity = async (
	salesActivityPageRequest: SalesActivityPageRequest
): Promise<SalesActivityResponse> => {
	try {
		const appliedFilters = getTableQueryFilters(
			salesActivityPageRequest.filters,
			false
		);
		let salesActivityURL = "";
		if (
			salesActivityPageRequest.paginate &&
			salesActivityPageRequest.next &&
			salesActivityPageRequest.next.length > 0
		) {
			salesActivityURL += `${salesActivityPageRequest.next}`;
		} else if (
			salesActivityPageRequest.paginate &&
			salesActivityPageRequest.previous &&
			salesActivityPageRequest.previous.length > 0
		) {
			salesActivityURL += `${salesActivityPageRequest.previous}`;
		} else {
			salesActivityURL += `included_feed_types=${salesActivityPageRequest.feedType.join(
				","
			)}`;
			salesActivityURL += `&feed_section=${salesActivityPageRequest.feedSection}`;
			salesActivityURL +=
				appliedFilters && appliedFilters.length > 0
					? `&${appliedFilters}`
					: "";
			salesActivityURL += `&${includeChildEntities([
				ChildEntityHydrationParams.PARENT_ENTITY_SUMMARY
			])}&limit=${
				salesActivityPageRequest.limit
			}&count_query_flag=${true}`;
		}

		const response: AxiosResponse<SalesActivityResponse> = await axios(
			postRequest(
				salesActivityUrl,
				{ query_string: urlencode(salesActivityURL) },
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getOneSalesActivity = async (
	getOneSaleActivityRequest: GetOneSaleActivityRequest
): Promise<SalesActivity> => {
	try {
		let url = getOneSalesActivityURL.replace(
			"{entity_id}",
			getOneSaleActivityRequest.salesActivityEntityId
		);
		url = `${url}?feed_type=${
			getOneSaleActivityRequest.SalesActivityEntityType
		}&${includeChildEntities([
			ChildEntityHydrationParams.PARENT_ENTITY_SUMMARY
		])}`;
		const response: AxiosResponse<SalesActivity> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteOneSalesActivity = async (
	deleteSalesActivity: SalesActivity
): Promise<DeletedRecord> => {
	try {
		let url = "";

		switch (deleteSalesActivity.feed_type) {
			case RecentActivityFeedType.Task:
				url = deleteOneSalesActivityURL
					.replace("{entity_type}", RecentActivityFeedType.Task)
					.replace("{entity_id}", deleteSalesActivity.id);
				break;
			case RecentActivityFeedType.LogEmail:
				url = deleteOneSalesActivityURL
					.replace("{entity_type}", "email_log")
					.replace("{entity_id}", deleteSalesActivity.id);
				break;
			case RecentActivityFeedType.LogCall:
				url = deleteOneSalesActivityURL
					.replace("{entity_type}", "call_log")
					.replace("{entity_id}", deleteSalesActivity.id);
				break;
			case RecentActivityFeedType.Meeting:
				url = deleteOneSalesActivityURL
					.replace("{entity_type}", RecentActivityFeedType.Meeting)
					.replace("{entity_id}", deleteSalesActivity.id);
				break;
			case RecentActivityFeedType.Comment:
				url = deleteOneCommentURL.replace(
					"{comment_id}",
					deleteSalesActivity.id
				);
				break;
			default:
				break;
		}

		const response: AxiosResponse<DeletedRecord> = await axios(
			deleteRequest(url, null, true, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const syncEntityWithPsa = async (
	syncEntityRequest: SyncEntityRequest
): Promise<any> => {
	try {
		const response: AxiosResponse<any> = await axios(
			postRequest(syncWithPSAUrl, syncEntityRequest, true, false, false)
		);

		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getUpdatedSyncData = async (
	request: SyncEntityRequest
): Promise<SyncData[]> => {
	try {
		const response: AxiosResponse<SyncData[]> = await axios(
			postRequest(getUpdatedSyncDataUrl, request, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const fetchMeetingClashStatus = async (
	startTime: number,
	endTime: number,
	id: string
): Promise<MeetingClashStatusResponse> => {
	const params = `?start_time=${startTime}&end_time=${endTime}`;
	const fetchMeetingURLParams = id.length
		? params.concat(`&id=${id}`)
		: params;
	try {
		const response: AxiosResponse<MeetingClashStatusResponse> = await axios(
			getRequest(
				fetchMeetingClashStatusURL + fetchMeetingURLParams,
				null,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const fetchAuditLogs = async (
	fetchAuditLogsRequest: FetchCategoryBasedAuditLogsRequest
): Promise<HistoryActivityResponse> => {
	try {
		const tableSorter = getTableQueryFilters(
			fetchAuditLogsRequest.filter,
			false
		);
		const syncSource = !!fetchAuditLogsRequest.sync_source?.length
			? `&sync_source=${fetchAuditLogsRequest.sync_source}`
			: "";

		const response: AxiosResponse<HistoryActivityResponse> = await axios(
			getRequest(
				fetchAuditLogsURL +
					`?page=${fetchAuditLogsRequest.page}&limit=${fetchAuditLogsRequest.limit}&log_source=${fetchAuditLogsRequest.log_source}&${tableSorter}${syncSource}`,
				null,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const fetchCustomDistributorAuditLogs = async (
	fetchAuditLogsRequest: FetchCustomDistributorAuditLogsRequest
): Promise<any> => {
	try {
		const response: AxiosResponse<HistoryActivityResponse> = await axios(
			getRequest(
				fetchCustomDistributorAuditLogsURL.replace(
					"{distributor_id}",
					fetchAuditLogsRequest.customDistributorId
				),
				null,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const retryFailedAuditLog = async (
	retryFailedAuditLogRequest: RetryFailedAuditLogsRequest
): Promise<any> => {
	try {
		const response: AxiosResponse<any> = await axios(
			postRequest(
				retryFailedAuditLogURL,
				retryFailedAuditLogRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getSalesActivityAutomationAuditLogs = async (
	salesActivityAutomationAuditLogsRequest: SalesActivityAutomationAuditLogsRequest
): Promise<SalesActivityAutomationAuditLogsResponse> => {
	try {
		const url =
			salesActivityAutomationAuditLogsURL.replace(
				"{rule_id}",
				salesActivityAutomationAuditLogsRequest.rule_id
			) +
			`;&page=${salesActivityAutomationAuditLogsRequest.page}&limit=${salesActivityAutomationAuditLogsRequest.limit}`;

		const response: AxiosResponse = await axios(
			getRequest(url, null, true, false, false)
		);

		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getAuditLogRedirectUrl = async (id: string): Promise<string> => {
	try {
		const url = getAuditLogRedirectLinkURL.replace("{id}", id);
		const response = await axios(getRequest(url, null, true, false, false));
		return response.data;
	} catch (err) {
		return Promise.reject(err);
	}
};

export const fetchSalesActivityAndAutomationViewMetadata = async (
	entity: ZomentumEntities
): Promise<CustomViewsMetadata> => {
	try {
		const response: AxiosResponse<CustomViewsMetadata> = await axios(
			getRequest(
				getSalesActivityViewMetadataURL.replace(
					"{entity_type}",
					entity
				),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getAllSalesActivityAndAutomationViews = async (
	entity: ZomentumEntities
): Promise<CustomViewResponse> => {
	try {
		const response: AxiosResponse<CustomViewResponse> = await axios(
			getRequest(
				getAllSalesActivityAndAutomationViewURL.replace(
					"{entity_type}",
					entity
				),
				null,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const createSalesActivityAndAutomationView = async (
	customViewRequest: CustomView
): Promise<CustomView> => {
	try {
		const response: AxiosResponse<CustomView> = await axios(
			postRequest(
				createSalesActivityAndAutomationViewURL,
				customViewRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const updateSalesActivityAndAutomationView = async (
	customViewRequest: CustomView
): Promise<CustomView> => {
	try {
		const response: AxiosResponse<CustomView> = await axios(
			putRequest(
				updateSalesActivityAndAutomationViewURL.replace(
					"{view_id}",
					customViewRequest.id
				),
				customViewRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const deleteSalesActivityAndAutomationView = async (
	customViewId: string
): Promise<unknown> => {
	try {
		const response: AxiosResponse<unknown> = await axios(
			deleteRequest(
				deleteSalesActivityAndAutomationViewURL.replace(
					"{view_id}",
					customViewId
				),
				null,
				true,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getSalesActivityAndAutomationListPost = async (
	salesAutomationRequest: ListPagePostRequest,
	version = "v2"
): Promise<SalesActivityAutomationResponse> => {
	try {
		const includedChildEntities = includeChildEntities(
			salesAutomationRequest.included_child_entities
		);
		const response: AxiosResponse<SalesActivityAutomationResponse> =
			await axios(
				postRequest(
					getSalesActivityAndAutomationListPostURL.replace(
						"{version}",
						version
					) + `?${includedChildEntities}`,
					salesAutomationRequest,
					true,
					false,
					false
				)
			);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getConflictMeetingsDetail = async (
	startTime: number
): Promise<ConflictedMeetigs[]> => {
	const startTimeURL = `?start_time=${startTime}`;
	try {
		const response: AxiosResponse<ConflictedMeetigs[]> = await axios(
			getRequest(
				getConflictMeetingsDetailURL + startTimeURL,
				null,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

type TestWebhookParamsBase = {
	entityId: string;
	entityType: string;
};

type TestWebhookParamsWithId = TestWebhookParamsBase & {
	webhookConfigId: string;
	webhookConfig?: never;
};

type TestWebhookParamsWithConfig = TestWebhookParamsBase & {
	webhookConfig: WebhookConfigCreateRequest;
	webhookConfigId?: never;
};

export type TestWebhookParams =
	| TestWebhookParamsWithId
	| TestWebhookParamsWithConfig;

export const testWebhook = async (
	params: TestWebhookParams
): Promise<WebhookTestResponse> => {
	try {
		const response: AxiosResponse<WebhookTestResponse> = await axios(
			postRequest("/v2/webhook/config/test/", params, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
